"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SendAllResultsRule = void 0;
const game_rule_1 = require("./game-rule");
class SendAllResultsRule extends game_rule_1.AbstractGameRule {
    applyRule(_commandHash, _existingDeal, instant, context) {
        return __awaiter(this, void 0, void 0, function* () {
            for (const player of context.playerManager.allPlayers) {
                if (!player.isBust) {
                    const roundResult = player.calculateRoundResult(context.playerManager.croupier.currentScore);
                    context.gameState.logicEventQueue.enqueue({
                        type: "onCurrentPlayerChanged",
                        instant,
                        payload: { player: player.clone() },
                    });
                    context.gameState.sendHandResult(player, roundResult, instant);
                }
            }
            context.gameState.moveToNextRound(instant);
            return Promise.resolve(true);
        });
    }
}
exports.SendAllResultsRule = SendAllResultsRule;
